import React from 'react';
import PropTypes from 'prop-types';

// `FileLink` expected
const FileNameCell = ({ cell, ...rest }) => {
  const { FileLink } = rest.row.original;
  return (
    <a href={FileLink} data-test={cell.value} target="_blank">
      <strong>{cell.value}</strong>
    </a>
  );
};

FileNameCell.propTypes = {
  cell: PropTypes.object.isRequired
};
export default FileNameCell;
